import React from 'react'
import styled from 'styled-components'
import Loader from '../../atoms/loader/Loader'
import StarIcon from '../../atoms/icons/StarIcon'
import { brandDarkGrey, brandIvory, brandOrange, brandWhite } from '../../../assets/consts/color'
import { primaryFont } from '../../../assets/consts/fonts'

const CustomButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;

  min-width: 214px;
  padding: 16px;
  line-height: 150%;

  border: none;
  background-color: ${({ modal }) => (modal ? brandWhite : brandIvory)};
  cursor: pointer;

  transition:
    filter 0.25s ease-in-out,
    color 0.25s ease-in-out;

  &:disabled {
    color: ${brandDarkGrey};
    cursor: auto;
  }

  &:hover {
    &:not(:disabled) {
      filter: brightness(0.8);
    }
  }

  span {
    font-family: ${primaryFont};
    font-size: 16px;
  }
`

const RatingItem = styled.div`
  width: 18px;
  height: 24px;

  color: ${({ checked }) => (checked ? brandOrange : '#D9D9D9')};
`

function AddReviewButton({ reviews, rating, isLoading, inModalWindow, ...rest }) {
  const isRatingPartial = (index) => rating - index > 0 && rating - index < 1

  return (
    <CustomButton modal={inModalWindow} {...rest}>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <span style={{ color: brandDarkGrey }}>{reviews} Reviews</span>
          <div className="flex">
            {Array(5)
              .fill(null)
              .map((_, index) => (
                <RatingItem key={index} checked={index + 1 <= Math.ceil(rating)}>
                  <StarIcon
                    maskWidth={isRatingPartial(index) && `${(rating - index).toFixed(2) * 100}%`}
                  />
                </RatingItem>
              ))}
          </div>
        </>
      )}
    </CustomButton>
  )
}

export default AddReviewButton
